// VariantForm/LicenseViewer.js
import React, { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  CircularProgress,
  Alert
} from "@mui/material";

export default function LicenseViewer({ product, reloadKey, onLoaded }) {
  const [loading, setLoading] = useState(false);
  const [licenses, setLicenses] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!product) {
      setLicenses([]);
      setError("");
      if (onLoaded) onLoaded("", []);
      return;
    }

    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const resp = await fetch(`/productos/ver-licencias/?product_id=${product.id}`, {
          credentials: "include"
        });
        const data = await resp.json();

        const emails = (data.emails || []).map((l) => ({
          id: l.id,
          email: l.email,
          password: l.password,
          stock: l.stock,
          type: "email"
        }));

        const codes = (data.codes || []).map((l) => ({
          id: l.id,
          code: l.code,
          stock: l.stock,
          type: "code"
        }));

        const all = [...emails, ...codes];
        setLicenses(all);

        const type =
          emails.length > 0 ? "email" : codes.length > 0 ? "code" : "";

        if (onLoaded) onLoaded(type, all);
      } catch (e) {
        setLicenses([]);
        setError("No se pudieron cargar las licencias");
        if (onLoaded) onLoaded("", []);
      }
      setLoading(false);
    };

    load();
  }, [product, reloadKey]);

  if (!product) return null;

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Typography sx={{ fontWeight: "bold", mb: 2 }}>
        Licencias existentes
      </Typography>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
          <CircularProgress size={24} />
        </Box>
      )}

      {!loading && error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {!loading && !error && licenses.length === 0 && (
        <Typography variant="body2">
          Este producto no tiene licencias registradas.
        </Typography>
      )}

      {!loading && !error && licenses.length > 0 && (
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: "#1565C0" }}>
              <TableCell sx={{ color: "#fff" }}>Tipo</TableCell>
              <TableCell sx={{ color: "#fff" }}>Email</TableCell>
              <TableCell sx={{ color: "#fff" }}>Password</TableCell>
              <TableCell sx={{ color: "#fff" }}>Código</TableCell>
              <TableCell sx={{ color: "#fff" }}>Stock</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {licenses.map((l) => (
              <TableRow key={l.id}>
                <TableCell>{l.type === "email" ? "Email" : "Código"}</TableCell>
                <TableCell>{l.email || "–"}</TableCell>
                <TableCell>{l.password || "–"}</TableCell>
                <TableCell>{l.code || "–"}</TableCell>
                <TableCell>{l.stock}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Paper>
  );
}
